<template>
  <v-list-item dense :class="[item.new ? 'newcolor' : '', item.changed ? 'changecolor' : '']" class="pr-0"
    @click="$emit('click')">
    <v-list-item-icon class="my-auto mr-3">
      <v-icon v-text="'mdi-webhook'" size="18" />
    </v-list-item-icon>
    <v-list-item-content class="py-auto">
      <v-list-item-title>
        {{ getTopicLabel(item.Topic) }} 🡒 {{ getActionFlagsLabel(item.ActionFlags) }}
      </v-list-item-title>
      <v-list-item-subtitle>
        <a :href="item.Url">{{ item.Url }}</a>
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action v-if="item.new || item.changed">
      <v-card :color="item.new ? 'green' : 'orange'" dark class="px-2 rounded-pill" offset-x="0" :offset-y="10">
        {{ item.new ? $t('servicesystem.common_objects.commonterms.new') :
          $t('servicesystem.common_objects.commonterms.changed') }}
      </v-card>
    </v-list-item-action>
    <v-list-item-action class="ma-0" style="width: unset;">
      <v-chip v-if="item.Locked" small color="disabled darken-4" text-color="white" class="mx-2 px-2"
        style="border-radius: 4px;">
        Locked
      </v-chip>
      <SpecialDeleteButton v-else :deleteFunc="handleDelete" :size="20"></SpecialDeleteButton>
    </v-list-item-action>
  </v-list-item>
</template>


<script>
import WebhookSubscriptionMixin from "@/views/admin/settings/webhooks/WebhookSubscriptionMixin.js";
import SpecialDeleteButton from "@/views/contracts/SpecialDeleteButton.vue";

export default {
  name: "WebhookSubscriptionListItem",
  props: {
    item: Object,
  },
  components: {
    SpecialDeleteButton,
  },
  mixins: [WebhookSubscriptionMixin],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {
    handleDelete() {
      this.$emit('delete', this.item);
    }
  },

  computed: {},

  watch: {},
};
</script>


<style lang='scss' scoped></style>
